import type { PropsWithChildren } from 'react';
import { Icon } from '../Icon';
import type { RewarbleIconsId } from '@repo/icons';
import clsx from 'clsx';

type TimelineItemVariant = 'completed' | 'pending' | 'failed';

type TimelineItemProps = PropsWithChildren & {
  variant: TimelineItemVariant
};

const ICONS: Record<TimelineItemVariant, RewarbleIconsId> = {
  completed: 'check',
  failed: 'xmark',
  pending: 'hourglass-half'
}

export const TimelineItem = ( { children, variant = 'pending' }: TimelineItemProps ) => {

  return (
    <div className={ 'group opacity-70 last:opacity-100 gap-2.5 grid grid-cols-[30px_1fr] gap-x-5' }>
      <div className={ 'flex flex-col items-center' }>
        <div className={ clsx(
          'border-[1.5px] rounded-full w-[30px] h-[30px] flex items-center justify-center',
          {
            'text-[#00B67A] border-[#00B67A]': variant === 'completed',
            'text-[#EF4444] border-[#EF4444]': variant === 'failed',
            'text-[#8584FE] border-[#8584FE]': variant === 'pending',
          }
        ) }>
          <Icon
            name={ ICONS[ variant ] }
            className={ 'text-xl size-5' }
          />
        </div>
        <div className={ 'flex-1 w-[1.5px] bg-[#C2BEBE20] group-last:hidden' } />
      </div>
      <div className={ 'pb-5 flex flex-col gap-2.5' }>
        { children }
      </div>
    </div>
  )
}
TimelineItem.displayName = 'TimelineItem';
